/* eslint-disable react-hooks/immutability -- these numeric settings update the existing field settings object directly. */
import {Observer} from "mobx-react";
import type {INumericFieldSettingsDefinition, NumericFormatting} from "../../../../../data/models/field/datatypes/Numeric";
import type {IFieldDataTypeSettingsProps} from "../../../../modules/settings/modules/field/datatypes/IFieldDataTypeSettingsProps";
import {SelectInputV5} from "../../../input/select/SelectInputV5";
import {FieldV5} from "../../FieldV5";
import {MathUtils} from "../../../../../utils/math/MathUtils";
import {NumberInputV5} from "./NumberInputV5";

const _options: {
	id: NumericFormatting;
	label: string;
}[] = [
	{
		id: "general",
		label: "General",
	},
	{
		id: "comma-style",
		label: "Comma Style", // format with a thousands separator
	},
	{
		id: "currency",
		label: "Currency",
	},
	// {
	// 	id: "percentage",
	// 	label: "Percentage",
	// },
];

const min = 0;
const max = 10;

export const NumericFieldSettingsV5 = (props: IFieldDataTypeSettingsProps) => {
	const {field, onChange} = props;

	const onInput = (value: number) => {
		const settings = field.dataTypeSettings as INumericFieldSettingsDefinition;

		settings.decimals = MathUtils.clamp(value, min, max);
		onChange();
	};

	return (
		<Observer>
			{() => {
				const settings = field.dataTypeSettings as INumericFieldSettingsDefinition;
				return (
					<>
						<FieldV5 label="Formatting">
							<SelectInputV5
								options={_options}
								selected={_options.find((option) => option.id === settings.formatting)}
								onChange={(option) => {
									settings.formatting = option.id;
									onChange();
								}}
								renderOptionWhenClosed={(option) => option.label}
								isSameWidth={true}
							/>
						</FieldV5>
						<FieldV5
							label="Decimal Places"
							className="decimals"
						>
							<NumberInputV5
								key={field.refId}
								value={settings.decimals}
								onInput={onInput}
								onChange={onInput}
								decimals={0}
								onlyNaturalNumbers={true}
							/>
						</FieldV5>
					</>
				);
			}}
		</Observer>
	);
};
